import type { CSSProperties, HTMLAttributes } from "react";
import { createStyles } from "./styling";

const useStyles = createStyles(({ css, token }) => ({
  main: css`
    background: ${token.colorBgContainer};
    min-height: 0;
    min-width: 0;
    overflow: hidden;
  `,
  root: css`
    background: ${token.colorBgContainer};
    display: grid;
    grid-template-columns:
      var(--ark-workspace-sidebar-width, 300px)
      minmax(0, 1fr);
    min-height: 0;
    overflow: hidden;
  `,
  singleColumnSm: css`
    @media (max-width: ${token.screenSMMax}px) {
      grid-template-columns: minmax(0, 1fr);
      overflow-y: auto;
    }
  `,
  singleColumnMd: css`
    @media (max-width: ${token.screenMDMax}px) {
      grid-template-columns: minmax(0, 1fr);
      overflow-y: auto;
    }
  `,
  singleColumnLg: css`
    @media (max-width: ${token.screenLGMax}px) {
      grid-template-columns: minmax(0, 1fr);
      overflow-y: auto;
    }
  `,
  sidebar: css`
    background: ${token.colorFillQuaternary};
    min-height: 0;
    min-width: 0;
    overflow: hidden;
  `,
}));

export function WorkspaceSplit({
  children,
  className,
  sidebarWidth,
  singleColumnAt,
  style,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  sidebarWidth?: CSSProperties["width"];
  singleColumnAt?: "sm" | "md" | "lg";
}) {
  const { cx, styles } = useStyles();
  const singleColumnClass = singleColumnAt
    ? {
        lg: styles.singleColumnLg,
        md: styles.singleColumnMd,
        sm: styles.singleColumnSm,
      }[singleColumnAt]
    : undefined;
  return (
    <div
      className={cx(styles.root, singleColumnClass, className)}
      style={
        sidebarWidth
          ? ({
              ...style,
              "--ark-workspace-sidebar-width":
                typeof sidebarWidth === "number"
                  ? `${sidebarWidth}px`
                  : sidebarWidth,
            } as CSSProperties)
          : style
      }
      {...props}
    >
      {children}
    </div>
  );
}

export function WorkspaceSidebar({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  const { cx, styles } = useStyles();
  return (
    <aside className={cx(styles.sidebar, className)} {...props}>
      {children}
    </aside>
  );
}

export function WorkspaceMain({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  const { cx, styles } = useStyles();
  return (
    <main className={cx(styles.main, className)} {...props}>
      {children}
    </main>
  );
}
